module.exports = __webpack_public_path__ + "assets/images/3f7e58a0f68cd25d8c8b50b181f19c6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icons/codewars.png
// module id = 723
// module chunks = 0